var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	98670: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(34205), __webpack_require__.e(12481), __webpack_require__.e(86763), __webpack_require__.e(44867)]).then(() => (() => (__webpack_require__(44867))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.16",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",
	},
	62863: {
		fallback: () => (Promise.all([__webpack_require__.e(95361), __webpack_require__.e(73393)]).then(() => (() => (__webpack_require__(73393))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.5.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",
	},
	303: {
		fallback: () => (Promise.all([__webpack_require__.e(95361), __webpack_require__.e(23620)]).then(() => (() => (__webpack_require__(23620))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.5.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",
	},
	99882: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(35430), __webpack_require__.e(2324)]).then(() => (() => (__webpack_require__(2324))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",
	},
	40406: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(18015)]).then(() => (() => (__webpack_require__(18015))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",
	},
	69536: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(99882), __webpack_require__.e(86285), __webpack_require__.e(34487), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",
	},
	5323: {
		fallback: () => (Promise.all([__webpack_require__.e(98670), __webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(68766), __webpack_require__.e(81383)]).then(() => (() => (__webpack_require__(81383))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",
	},
	86285: {
		fallback: () => (Promise.all([__webpack_require__.e(40406), __webpack_require__.e(62190), __webpack_require__.e(80436)]).then(() => (() => (__webpack_require__(80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",
	},
	63880: {
		fallback: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(13334))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/global-environments",
	},
	59868: {
		fallback: () => (Promise.all([__webpack_require__.e(99882), __webpack_require__.e(69536), __webpack_require__.e(5323), __webpack_require__.e(86285), __webpack_require__.e(63880), __webpack_require__.e(60130), __webpack_require__.e(68766), __webpack_require__.e(72370), __webpack_require__.e(76041), __webpack_require__.e(34205), __webpack_require__.e(34487), __webpack_require__.e(36712), __webpack_require__.e(35430), __webpack_require__.e(12481), __webpack_require__.e(99737), __webpack_require__.e(91494)]).then(() => (() => (__webpack_require__(91494))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/utils",
	},
	68766: {
		fallback: () => (Promise.all([__webpack_require__.e(34205), __webpack_require__.e(86763), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.16",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",
	},
	77638: {
		fallback: () => (Promise.all([__webpack_require__.e(62190), __webpack_require__.e(81351), __webpack_require__.e(49122)]).then(() => (() => (__webpack_require__(49122))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",
	},
	94694: {
		fallback: () => (__webpack_require__.e(34456).then(() => (() => (__webpack_require__(34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",
	},
	2140: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(99882), __webpack_require__.e(40406), __webpack_require__.e(36351), __webpack_require__.e(59868), __webpack_require__.e(390), __webpack_require__.e(35741)]).then(() => (() => (__webpack_require__(35741))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/flags",
	},
	20402: {
		fallback: () => (Promise.all([__webpack_require__.e(99882), __webpack_require__.e(81897)]).then(() => (() => (__webpack_require__(81897))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/access-control",
	},
	26764: {
		fallback: () => (Promise.all([__webpack_require__.e(31369), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(63450))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/state/route",
	},
	3465: {
		fallback: () => (__webpack_require__.e(24074).then(() => (() => (__webpack_require__(24074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.2.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/icon",
	},
	60495: {
		fallback: () => (Promise.all([__webpack_require__.e(93482), __webpack_require__.e(74926)]).then(() => (() => (__webpack_require__(74926))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.2.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/dialog",
	},
	21672: {
		fallback: () => (Promise.all([__webpack_require__.e(68766), __webpack_require__.e(85114)]).then(() => (() => (__webpack_require__(85114))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "angular-auth-oidc-client",
	},
	99737: {
		fallback: () => (__webpack_require__.e(66231).then(() => (() => (__webpack_require__(66231))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-device-detector",
	},
	17548: {
		fallback: () => (Promise.all([__webpack_require__.e(99882), __webpack_require__.e(86285), __webpack_require__.e(63880), __webpack_require__.e(60130), __webpack_require__.e(59868), __webpack_require__.e(390), __webpack_require__.e(72370), __webpack_require__.e(80097), __webpack_require__.e(72556), __webpack_require__.e(93482), __webpack_require__.e(99290), __webpack_require__.e(82057), __webpack_require__.e(40871)]).then(() => (() => (__webpack_require__(40871))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/webapp/shared/services/auth",
	},
	31369: {
		fallback: () => (Promise.all([__webpack_require__.e(98670), __webpack_require__.e(303), __webpack_require__.e(69536), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(32175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/router-store",
	},
	43604: {
		fallback: () => (Promise.all([__webpack_require__.e(99882), __webpack_require__.e(63880), __webpack_require__.e(76041), __webpack_require__.e(92434), __webpack_require__.e(99492)]).then(() => (() => (__webpack_require__(99492))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/webapp/shared/services/common",
	},
	10398: {
		fallback: () => (__webpack_require__.e(8880).then(() => (() => (__webpack_require__(8880))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/webapp/shared/guards",
	},
	36988: {
		fallback: () => (Promise.all([__webpack_require__.e(48765), __webpack_require__.e(90353), __webpack_require__.e(38223), __webpack_require__.e(35723), __webpack_require__.e(94806), __webpack_require__.e(16373), __webpack_require__.e(43268), __webpack_require__.e(47101), __webpack_require__.e(46529)]).then(() => (() => (__webpack_require__(91798))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/layouts",
	},
	53010: {
		fallback: () => (__webpack_require__.e(70347).then(() => (() => (__webpack_require__(70347))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/effects",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"303": [
		303
	],
	"2140": [
		2140
	],
	"5323": [
		5323
	],
	"17548": [
		17548
	],
	"22322": [
		43604
	],
	"31369": [
		31369
	],
	"40406": [
		40406
	],
	"59868": [
		59868
	],
	"62863": [
		62863
	],
	"62891": [
		20402,
		26764
	],
	"63880": [
		63880
	],
	"68766": [
		68766
	],
	"69536": [
		69536
	],
	"72370": [
		77638,
		94694
	],
	"82057": [
		21672
	],
	"82374": [
		10398,
		36988,
		53010
	],
	"86285": [
		86285
	],
	"98670": [
		98670
	],
	"99290": [
		3465,
		60495
	],
	"99737": [
		99737
	],
	"99882": [
		99882
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}